export default __webpack_public_path__ + "static/media/phone.de95633a.svg";